/**
 * WebSocket URL生成ユーティリティ
 * 環境に応じて適切なWebSocket URLを生成します
 */

export function getWebSocketUrl(path: string): string {
  const host = window.location.host
  const protocol = window.location.protocol

  // 本番環境かローカル環境かを判定
  const isProduction = protocol === 'https:'
  const isLocalhost = host.includes('localhost') || host.includes('127.0.0.1')

  if (isLocalhost) {
    // ローカル開発環境
    return `ws://localhost:8000${path}`
  } else if (isProduction) {
    // 本番環境（HTTPS）
    return `wss://${host}${path}`
  } else {
    // その他（HTTP環境）
    return `ws://${host}${path}`
  }
}

/**
 * WebSocket用のベースURLを取得
 */
export function getWebSocketBaseUrl(): string {
  const host = window.location.host
  const protocol = window.location.protocol

  const isProduction = protocol === 'https:'
  const isLocalhost = host.includes('localhost') || host.includes('127.0.0.1')

  if (isLocalhost) {
    return 'ws://localhost:8000'
  } else if (isProduction) {
    return `wss://${host}`
  } else {
    return `ws://${host}`
  }
}